var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 200 200",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145,17.5H90a30.09,30.09,0,0,0-30,30H55a30.09,30.09,0,0,0-30,30v75a30.09,30.09,0,0,0,30,30h55a30.09,30.09,0,0,0,30-30h5a30.09,30.09,0,0,0,30-30v-75a30.09,30.09,0,0,0-30-30Zm-25,135a10,10,0,0,1-10,10H55a10,10,0,0,1-10-10v-75a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10Zm35-30a10,10,0,0,1-10,10h-5v-55a30.09,30.09,0,0,0-30-30H80a10,10,0,0,1,10-10h55a10,10,0,0,1,10,10v75Zm-55,10H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Zm0-30H65a10,10,0,0,0,0,20h35a10,10,0,0,0,0-20Z",
    fill: "#00857C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateButton);
export default __webpack_public_path__ + "static/media/DuplicateButton.b87785bb5bb7f299d4383d6a25cf1f7e.svg";
export { ForwardRef as ReactComponent };